/* eslint-disable no-debugger */
import { Fragment } from "react";
import StandardKendoReport from "@usas/ui-web/components/embeddedReports/kendoReports/StandardKendoReport";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import useClubTimesWithParams from "./UseClubTimesWithParams";
import DatePicker from "@usas/ui-web/components/datepickers/DatePicker";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import EventMultiSelect from "@usas/ui-web/components/multiSelect/eventMultiSelect/EventMultiSelect";

// NOTE: if you have are using basic single select parameters like DDLs and textboxes you can dynamically gerenerate the parametes from json.
// see ClubTimesNew.jsx. If you want to use a specic complex component like EventMultiSelect you can create a form as in this example.

const ClubTimesWithParams = () => {
  const {
    formState,
    errorState,
    reportParameters,
    parameters,
    columns,
    modalState,
    onModalCancelClicked,
    handleSubmit,
    onFormValueChanged,
    updateFormState,
    onRunReportClicked
  } = useClubTimesWithParams();

  return (
    <Fragment>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <DatePicker
              label="Start Date"
              name="startDate"
              value={formState.startDate}
              error={errorState.startDate}
              message={errorState.startDate}
              countOfYears={150}
              startYearOffset={-149}
              onChange={(value) => { updateFormState('startDate', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <DatePicker
              label="End Date"
              name="endDate"
              value={formState.endDate}
              error={errorState.endDate}
              message={errorState.endDate}
              countOfYears={150}
              startYearOffset={-149}
              onChange={(value) => { updateFormState('endDate', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <EventMultiSelect
              label="Events"
              name="events"
              value={formState.events}
              error={errorState.events}
              message={errorState.events || "Events are required"}
              onChange={(value) => { onFormValueChanged('events', value); }} />
          </div>
        </div>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={(e) => onRunReportClicked(e)}>Run</PrimaryButton>&nbsp;
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={95}
        maxWidth={1800}
        displayPopUp={modalState.displayPopUp}
        onModalCanceled={onModalCancelClicked}>
        <StandardKendoReport
          reportInfoId={263}
          reportParameters={reportParameters}
          title="Club Times Report"
          parameters={parameters}
          columns={columns}
          usePagination={true}
          pageSize={10}
          enablePdfExport={true}
          enableExcelExport={true}
          gridHeight="400px"
        />
      </PopUpModal>
    </Fragment>
  );
}

export default ClubTimesWithParams;